import React, { useState } from "react";
import styled from "styled-components";
import { makeStyles } from "@mui/styles";
import { spacing } from "@mui/system";
import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormGroup,
  Select as MuiSelect,
  TextField as MuiTextField,
  Button as MuiButton,
  FormControl,
  InputLabel,
  MenuItem,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { put, post } from "../api/actions";
import { get as getPMs } from "../api/actions"

const TextField = styled(MuiTextField)(spacing);
const Select = styled(MuiSelect)(spacing);

const PropertyManagerForm = (props) => {
  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    loadingIcon: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
    },
  }));

  const [newPm, setNewPM] = useState({
    name: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    statusId: "",
    developerId: "",
    billingEmail: "",
    delinquencyEmail: "",
    contactName: "",
    email: "",
    notes: "",
    stopSetupFee: 0,
    stopLateFee: 0,
    stopPayments: 0,
    creditLateFeesOnMoveOut: 0,
    // TODO: Re-enable after apl-property-service deploys notifyPmFinalBills schema + migration
    // notifyPmFinalBills: 0,
  });

  console.log(props)
  const handleSelectedAccountStatusChange = (event) => {
    onFieldChange(event);
    //setAccountState(event.target.value);
  };

  const save = async () => {
    const payload = { ...newPm };
    if (payload.developerId === '' || payload.developerId === null) {
      delete payload.developerId;
    }
    payload.stopSetupFee = String(payload.stopSetupFee);
    payload.stopLateFee = String(payload.stopLateFee);
    // stopPayments must stay a number — property-service tv4 schema type is 'number'
    // (unlike stopSetupFee / stopLateFee / creditLateFeesOnMoveOut which are strings).
    payload.creditLateFeesOnMoveOut = String(payload.creditLateFeesOnMoveOut);
    await props.post(payload)
    await props.getPMs();
    await props.onUpdate();

  };

  const onFieldChange = (event) => {
    let value = event.target.value;
    setNewPM({
      ...newPm,
      [event.target.name]: value,
    });
  };

  const toggleField = (field) => {
    setNewPM(prev => ({ ...prev, [field]: prev[field] ? 0 : 1 }));
  };

  const [PropertyManagerState, setPropertyManagerState] = React.useState("");
  const classes = useStyles();
  const dispatch = useDispatch();


  return (
    <Card>
      <CardContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              label="Name"
              type="text"
              onChange={onFieldChange}
              name="name"
              value={newPm.name}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />

          </Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              label="Phone"
              type="text"
              onChange={onFieldChange}
              name="phone"
              value={newPm.phone}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Address 1"
              type="text"
              onChange={onFieldChange}
              name="address1"
              value={newPm.address1}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Address 2"
              type="text"
              onChange={onFieldChange}
              name="address2"
              value={newPm.address2}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              label="City"
              type="text"
              onChange={onFieldChange}
              name="city"
              value={newPm.city}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="State"
              type="text"
              onChange={onFieldChange}
              value={newPm.state}
              name="state"
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Zip"
              type="text"
              onChange={onFieldChange}
              name="zip"
              value={newPm.zip}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Box>
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="statusIdLabel">Status</InputLabel>
            <Select
              labelId="statusId"
              id="statusId"
              label="Status"
              onChange={onFieldChange}
              value={newPm.statusId || ''}
              name="statusId"
            >
              {props.apl.genericTypes.propertyManagerStatus.data.map(
                (item, index) => (
                  <MenuItem key={item.id} id="AccountStatusOption1" value={item.id}>
                    {item.description}
                  </MenuItem>
                )
              )}
            </Select>
          </FormControl>
          <TextField
            label="Contact Name"
            type="text"
            onChange={onFieldChange}
            name="contactName"
            value={newPm.contactName}
            required
            fullWidth
            variant="outlined"
            InputLabelProps={{ shrink: true }}
          />
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              label="Email"
              type="text"
              onChange={onFieldChange}
              name="email"
              value={newPm.email}
              required
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Billing Email"
              type="text"
              onChange={onFieldChange}
              name="billingEmail"
              value={newPm.billingEmail}
              required
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Delinquency Email"
              type="text"
              onChange={onFieldChange}
              name="delinquencyEmail"
              value={newPm.delinquencyEmail}
              required
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Box>
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="developerIdLabel">Developer</InputLabel>
            <Select
              labelId="developerId"
              id="developerId"
              label="Developer"
              onChange={onFieldChange}
              value={newPm.developerId || ''}
              name="developerId"
            >
              {(props.developers?.data?.developersList?.items || []).map(
                (item, index) => (
                  <MenuItem key={item.id} id="DeveloperOption" value={item.id}>
                    {item.name}
                  </MenuItem>
                )
              )}
            </Select>
          </FormControl>
          <TextField
            label="Notes"
            type="text"
            onChange={onFieldChange}
            name="notes"
            value={newPm.notes}
            multiline
            rows={3}
            fullWidth
            variant="outlined"
            InputLabelProps={{ shrink: true }}
          />
          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={newPm.stopSetupFee === 1}
                    onChange={() => toggleField('stopSetupFee')}
                    name="stopSetupFee"
                  />
                }
                label="Stop Setup Fee"
              />
            </FormGroup>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={newPm.stopLateFee === 1}
                    onChange={() => toggleField('stopLateFee')}
                    name="stopLateFee"
                  />
                }
                label="Stop Late Fee"
              />
            </FormGroup>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={newPm.stopPayments === 1}
                    onChange={() => toggleField('stopPayments')}
                    name="stopPayments"
                  />
                }
                label="Stop Payments"
              />
            </FormGroup>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={newPm.creditLateFeesOnMoveOut === 1}
                    onChange={() => toggleField('creditLateFeesOnMoveOut')}
                    name="creditLateFeesOnMoveOut"
                  />
                }
                label="Credit Late Fees on Move-Out"
              />
            </FormGroup>
            {/* TODO: Re-enable after apl-property-service deploys notifyPmFinalBills schema + migration
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={newPm.notifyPmFinalBills === 1}
                    onChange={() => toggleField('notifyPmFinalBills')}
                    name="notifyPmFinalBills"
                  />
                }
                label="Notify PM Final Bills"
              />
            </FormGroup>
            */}
            <Box sx={{ marginLeft: 'auto' }}>
              <MuiButton variant="contained" onClick={save} color="secondary">
                Save
              </MuiButton>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

// Component Properties
PropertyManagerForm.propTypes = {
  propertyManagers: PropTypes.object.isRequired,
  owners: PropTypes.object.isRequired,
  propertyManagerStatuses: PropTypes.object.isRequired,
  put: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  getPMs: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired
};

function PropertyManagerFormState(state) {
  return {
    propertyManagers: state.propertyManagers,
    owners: state.owners,
    propertyManagerStatuses: state.propertyManagerStatuses,
    apl: state.apl,
    developers: state.developers
  };
}
export default connect(PropertyManagerFormState, { put, post , getPMs})(
  PropertyManagerForm
);
